import { toast } from "react-toastify";

const ExecuteActionWithToaster = async (dispatch: any, action: any) => {
  try {
    return await dispatch(action)
      .then((res: any) => {
        const response = res?.payload;

        if ([200, 201].includes(response?.status)) {
          toast.success(response?.message || "Command sent successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            draggable: true,
            pauseOnHover: true,
          });
        } else if ([204, 400, 401, 403, 404].includes(response?.status)) {
          toast.warning(
            response?.message || "Action completed with warnings.",
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              draggable: true,
              pauseOnHover: true,
            }
          );
        } else {
          toast.error(response?.message || "An unexpected error occurred.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            draggable: true,
            pauseOnHover: true,
          });
        }
        return res;
      })
      .catch((error: any) => {
        toast.error(
          error?.message || "An error occurred while executing the action.",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            draggable: true,
            pauseOnHover: true,
          }
        );
        return { error: error };
      });
  } catch (error: any) {
    toast.error(error?.message || "An unexpected error occurred.", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      draggable: true,
      pauseOnHover: true,
    });
    return { error: error };
  }
};

export default ExecuteActionWithToaster;
